import React from 'react';

import SimpleField from './simple';

export default function CurrencyDealField(props) {
  return <SimpleField {...props} type="currency" />;
}
